import classNames from 'classnames';
import {StaticImport} from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';

import Chicken from '../../../resources/img/leaders/Chicken.svg';
import Fernando from '../../../resources/img/leaders/Fer.svg';
import Kevin from '../../../resources/img/leaders/Kevin.svg';
import Ro from '../../../resources/img/leaders/Ro.svg';
import Sal from '../../../resources/img/leaders/Sal.svg';
import Sam from '../../../resources/img/leaders/Sam.svg';
import Sheep from '../../../resources/img/leaders/Sheep.svg';

type Props = {
  className?: string;
};

function createLeaderIcon(src: StaticImport, alt: string) {
  // noinspection UnnecessaryLocalVariableJS
  const LeaderIcon = ({className}: Props) => (
    <div className={classNames('relative', className)}>
      <Image src={src} layout={'fill'} objectFit={'contain'} alt={alt} aria-hidden />
    </div>
  );

  return LeaderIcon;
}

export const LEADERS = {
  fer: createLeaderIcon(Fernando, 'Leader icon fer'),
  sal: createLeaderIcon(Sal, 'Leader icon sal'),
  chicken: createLeaderIcon(Chicken, 'Leader icon chicken'),
  sam: createLeaderIcon(Sam, 'Leader icon sam'),
  ro: createLeaderIcon(Ro, 'Leader icon ro'),
  kev: createLeaderIcon(Kevin, 'Leader icon kev'),
  sheep: createLeaderIcon(Sheep, 'Leader icon sheep'),
};

export type LeaderIconId = keyof typeof LEADERS;
